"use strict";
/** @module utils */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEmail = exports.formatDuration = exports.toTitleCase = void 0;
/**
 * Format string to title case.
 * @param s String to format.
 * @return Formatted string.
 */
function toTitleCase(s) {
    return s.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
}
exports.toTitleCase = toTitleCase;
/**
 * Format duration.
 * @param duration
 * @return Duration formatted as string.
 */
function formatDuration(duration) {
    var components = [];
    var years = duration.years();
    if (duration.years() > 0) {
        components.push(years + "Y");
    }
    var months = duration.months();
    if (duration.months() > 0) {
        components.push(months + "M");
    }
    var days = duration.days();
    if (duration.days() > 0) {
        components.push(days + "d");
    }
    var hours = duration.hours();
    if (duration.hours() > 0) {
        components.push(hours + "h");
    }
    var minutes = duration.minutes();
    if (duration.minutes() > 0) {
        components.push(minutes + "m");
    }
    var seconds = duration.seconds();
    if (duration.seconds() > 0) {
        components.push(seconds + "s");
    }
    return components.join(' ');
}
exports.formatDuration = formatDuration;
/**
 * Validate email.
 * @param email Email to be validated.
 * @return True if valid email.
 */
function isValidEmail(email) {
    // tslint:disable-next-line
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
exports.isValidEmail = isValidEmail;
//# sourceMappingURL=format.js.map